<template>
  <el-row class="page-access-component">
    <el-row v-if="enablePermissions">
      <el-row class="label">
        <el-alert type="error" v-show="!isEmpty(errorMsgPermissions)">{{
          errorMsgPermissions
        }}</el-alert>
        <el-checkbox
          :indeterminate="isIndeterminatePermissions"
          v-model="checkAllPermissions"
          @change="handleCheckAllPermissions"
          >{{ $t("Comn_permissions") }}</el-checkbox
        >
      </el-row>
      <el-row class="permissions-checkbox-container">
        <div
          v-for="(newPermission, key1) in permissionsObj"
          :key="key1"
          class="permissions-checkbox-row"
        >
          <el-col :span="8">
            <p style="width: 200px; color: #6C7B8A">
              {{ newPermission.name }}
            </p>
          </el-col>
          <el-col :span="16">
            <el-checkbox-group
              :value="checkedPermissionsNew[newPermission.key]"
              :key="newPermission.name"
              @input="
                handleCheckboxChange($event, newPermission.key, newPermission)
              "
            >
              <el-checkbox
                v-for="(permission, actionName) in newPermission.allowedActions"
                :label="permission"
                :key="`${newPermission.name} ${actionName}`"
                >{{ getLabel(actionName) }}</el-checkbox
              >
            </el-checkbox-group>
          </el-col>
          <!-- <p>{{ newPermission.name }}</p> -->
        </div>
      </el-row>
    </el-row>
    <el-row v-if="enableLocations">
      <el-row class="label">
        <el-alert type="error" v-show="!isEmpty(errorMsgLocations)">{{
          errorMsgLocations
        }}</el-alert>
        <el-checkbox
          :indeterminate="isIndeterminateLocations"
          v-model="checkAllLocations"
          @change="handleCheckAllLocations"
          >{{ $t("Comn_locations") }}</el-checkbox
        >
      </el-row>
      <el-row class="location-row">
        <el-checkbox-group
          v-model="checkedLocations"
          @change="handleCheckedLocationsChange"
        >
          <template v-for="location in locations">
            <el-checkbox :key="location._id" :label="location._id">{{
              location.name
            }}</el-checkbox>
          </template>
        </el-checkbox-group>
      </el-row>
    </el-row>
  </el-row>
</template>
<script>
export default {
  props: {
    enablePermissions: {
      default: false
    },
    enableLocations: {
      default: false
    },
    givenPermissions: {
      default: () => []
    },
    allotedLocations: {
      default: () => []
    },
    errorMsgLocations: {
      default: ""
    },
    errorMsgPermissions: {
      default: ""
    },
    userType: {
      default: ""
    },
    type: {
      default: ""
    }
  },
  data: function() {
    return {
      isIndeterminatePermissions: true,

      checkAllLocations: false,
      checkAllPermissions: false,
      checkedPermissions: [],
      checkedPermissionsNew: {
        MANAGE_OVERVIEW: [],
        MANAGE_CULTURE: [],
        MANAGE_SCHEDULES: [],
        MANAGE_DEVICES: [],
        MANAGE_ABW: [],
        MANAGE_HARVEST: [],
        MANAGE_MEDICINE: [],
        MANAGE_LAB_TESTS: [],
        MANAGE_STOCK: []
      },
      checkedLocations: [],
      resources: []
    };
  },

  watch: {
    userType(newType, oldType) {
      if (newType === "POND_TECHNICIAN" || newType === "POND_WORKER") {
        this.checkedPermissionsNew = this.$lodash.cloneDeep(
          this.getInitPermissions
        );
        Object.entries(this.checkedPermissionsNew).forEach(([key, value]) => {
          Object.values(this.permissionsObj[key].allowedActions).forEach(
            item => {
              if (this.isCheckedDefault(item, newType)) {
                this.checkedPermissionsNew[key].push(item);
              }
            }
          );
        });
        this.handleCheckedPermissionsChange();
      }
    }
  },
  computed: {
    locations() {
      return this.$store.getters["user/getUserLocations"];
    },
    locationIds() {
      return this.locations.map(location => location._id);
    },
    getInitPermissions() {
      return {
        MANAGE_OVERVIEW: [],
        MANAGE_CULTURE: [],
        MANAGE_SCHEDULES: [],
        MANAGE_DEVICES: [],
        MANAGE_ABW: [],
        MANAGE_HARVEST: [],
        MANAGE_MEDICINE: [],
        MANAGE_LAB_TESTS: [],
        MANAGE_STOCK: []
      };
    },
    allPermissions() {
      // return Object.values(this.permissions).map(permission => permission.key);
      let allPermissions = {};
      Object.values(this.permissionsObj).map(({ key, allowedActions }) => {
        const actions = Object.values(allowedActions);

        allPermissions[key] = actions;
        return {
          [key]: actions
        };
      });

      return allPermissions;

      // get the data in the selection format
      // key and 3 array
    }
  },
  mounted() {
    this.checkedPermissions = this.givenPermissions;
    if (this.type === "create") {
      this.locationIds.length > 0 &&
        this.checkedLocations.push(this.locationIds[0]);
    } else {
      this.checkedLocations = this.allotedLocations;
      Object.entries(this.checkedPermissionsNew).forEach(([key, value]) => {
        Object.values(this.permissionsObj[key].allowedActions).forEach(item => {
          if (this.isChecked(item)) {
            this.checkedPermissionsNew[key].push(item);
          }
        });
      });
    }

    this.handleCheckedPermissionsChange(this.givenPermissions);
    this.handleCheckedLocationsChange(this.checkedLocations);
  },
  methods: {
    isCheckedDefault(list, role) {
      let allPresent = true;
      list.forEach(item => {
        if (this.getDefaultPermissions[role].includes(item)) {
        } else {
          allPresent = false;
        }
      });
      return allPresent;
    },
    isChecked(list) {
      let allPresent = true;
      list.forEach(item => {
        if (this.givenPermissions.includes(item)) {
        } else {
          allPresent = false;
        }
      });
      return allPresent;
    },
    isEmpty(value) {
      if (value == null) return true;
      const type =
        value != null && typeof value === "object"
          ? Array.isArray(value)
            ? "array"
            : "object"
          : typeof value;
      switch (type) {
        case "undefined":
          return true;
        case "string":
          return value === "";
        case "array":
          return value.length === 0;
        case "object":
          return Object.keys(value) === 0;
        default:
          console.error("Pondlogs*****Type UnKnown " + value);
      }
    },
    handleCheckedPermissionsChange: function(value) {
      // const checkedCount = value.length;
      // this.checkAllPermissions = checkedCount === this.allPermissions.length;
      // this.isIndeterminatePermissions =
      //   checkedCount > 0 && checkedCount < this.allPermissions.length;
      //chech if all checked

      this.checkAllPermissions = this.areAllChecked();
      this.isIndeterminatePermissions = !this.areAllChecked();

      const currPermissions = [
        ...new Set(Object.values(this.checkedPermissionsNew).flat(2))
      ];

      this.$emit("selectedPermissions", currPermissions);
    },
    areAllChecked() {
      // const totalPermissions = Object.values(
      //   Object.values(this.permissionsObj).allowedActions
      // );
      let totalPermissions = 0;
      let totalCurrentPermissions = 0;
      // return totalPermissions;
      Object.values(this.permissionsObj).forEach(({ allowedActions }) => {
        totalPermissions += Object.values(allowedActions).flat(2).length;
      });

      Object.values(this.checkedPermissionsNew).forEach(permission => {
        permission.forEach(item => {
          totalCurrentPermissions += item.length;
        });
      });

      return totalPermissions === totalCurrentPermissions;
    },
    handleCheckedLocationsChange: function(value) {
      const checkedCount = value.length;
      this.checkAllLocations = checkedCount === this.locations.length;
      this.isIndeterminateLocations =
        checkedCount > 0 && checkedCount < this.locations.length;
      this.$emit("selectedLocations", value);
    },
    handleCheckAllLocations: function(value) {
      this.checkedLocations = value ? this.locationIds : [];
      this.isIndeterminateLocations = false;
      this.$emit("selectedLocations", this.checkedLocations);
    },
    handleCheckAllPermissions: function(value) {
      this.checkedPermissionsNew = value
        ? this.allPermissions
        : this.getInitPermissions;
      this.isIndeterminatePermissions = false;
      const currentPermissions = [
        ...new Set(Object.values(this.checkedPermissionsNew).flat(2))
      ];
      this.$emit("selectedPermissions", currentPermissions);
    },
    hasView(value) {
      let hasView = false;
      value.forEach((value, index) => {
        console.log(value, value[index][0][0], index);
        if (value[index][0][0] === "V") {
          console.log(value[index][0][0]);
          hasView = true;
        }
      });
      return hasView;
    },
    handleCheckboxChange: function(value, key, allPermission) {
      this.checkedPermissionsNew[key] = this.updateViewPermissions(
        value,
        allPermission
      );

      this.handleCheckedPermissionsChange();
    },
    updateViewPermissions(value, allPermission) {
      if (value.length > 0) {
        if (value[0][0][0] === "D" || value[0][0][0] === "U") {
          if (
            value.length < 3 &&
            value.length === 1 &&
            value[0][0][0] !== "V"
          ) {
            value.push(allPermission.allowedActions.view);
          } else if (
            value.length < 3 &&
            value.length === 2 &&
            value[0][0][0] !== "V" &&
            value[1][0][0] !== "V"
          ) {
            value.push(allPermission.allowedActions.view);
          }
        }
      }
      return value;
    },
    getLabel(permission) {
      if (permission === "view") {
        return this.$t("Comn_view");
      } else if (permission === "update") {
        return this.$t("Comn_update");
      } else {
        return this.$t("Comn_delete");
      }
    }
  }
};
</script>

<style lang="scss">
.page-access-component {
  .col-3 {
    column-fill: balance;
    column-count: 3;
  }
  .label {
    font-size: 14px;
    margin: 12px 0px;
  }
  .el-checkbox__label {
    // @include normal-text;
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2,
      true
    );
  }
  .location-row {
    text-transform: capitalize;
    .el-checkbox-group {
      display: grid;
      grid-template-columns: 150px 150px 150px 150px;
    }
  }
  .permissions-checkbox-container {
    display: flex;
    flex-direction: column;

    .permissions-checkbox-row {
      display: flex;
      align-items: center;
      margin-bottom: 2px;
      margin-top: 2px;
      p {
        @include responsiveProperty(
          font-size,
          $app_font_size_small,
          $app_font_size_1,
          $app_font_size_2
        );
      }
    }
  }
}
</style>
